export const SessionStorageName = 'state'
